// extracted by mini-css-extract-plugin
export default {"breadcrumb":"hk-z","breadcrumbItem":"ik-z"};